import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLTimeElement extends HTMLElement { constructor(tagName: string = 'TIME', ownerDocument?: any) { super(tagName, ownerDocument); } }
